<template>
  <AccountWrapper class="content">
    <template #title>{{ t('account.generalInfo.latestPurchase') }}</template>
    <template #subtitle>
      {{ t('account.generalInfo.latestPurchaseSubtitle') }}
    </template>

    <div class="last-order">
      <div v-if="isLoading">Loading...</div>
      <div v-else-if="error">Error: {{ error.message }}</div>
      <AccountOrder v-else :order="order" :is-meta-visible="false" />
    </div>

    <hr class="my-6" />

    <div class="user-balance">
      <h4 class="mb-1 text-lg font-semibold">
        {{ t('account.generalInfo.accountBalance') }}
      </h4>
      <h5 class="mb-2 text-gray-500 text-sm font-normal">
        {{ t('account.generalInfo.accountBalanceSubtitle') }}
      </h5>

      <div class="balance">
        <img src="/cart/giftbox.png" alt="" />

        <div class="balance__info">
          <div class="balance__title">
            {{ t('account.generalInfo.yourAccountBalance') }}
          </div>
          <div class="balance__amount">{{ getBalance }}</div>
        </div>
      </div>
    </div>
  </AccountWrapper>
</template>

<script setup lang="ts">
const { getUserOrders, orders, user } = useAccount()

const { locale } = useI18n()
const { t } = useI18n()

const isLoading = ref(false)
const error = ref(null)

const getBalance = computed(() => {
  return formatPriceAmount(
    user?.value?.data?.balance?.amount || 0,
    locale.value
  )
})

const order = computed(() => {
  return orders.value[0] || []
})

onMounted(async () => {
  if (orders.value.length) return
  await getUserOrders()
})

definePageMeta({
  middleware: ['auth'],
  requiresAuth: true,
  isSimpleFooter: true,
})
</script>

<style lang="postcss" scoped>
.content {
  :deep(.account-area__content) {
    box-shadow: 0 0 20px 0 rgba(76, 87, 125, 0.06);

    @apply p-6 rounded-lg;
  }
}

.user-balance {
  .balance {
    box-shadow: 0 0 20px 0 rgba(76, 87, 125, 0.06);

    @apply inline-flex gap-2 items-center p-2.5 rounded-lg;

    img {
      @apply w-[60px] h-[60px] object-cover object-left-top rounded-lg;
    }

    &__title {
      @apply text-xs font-medium mb-1;
    }

    &__amount {
      @apply text-xs font-normal text-gray-600;
    }
  }
}
</style>
